
import MarketAnalysisChart from "@/components/marketAnalysis/MarketAnalysisChart";
import MarketAnalysisKpis from "@/components/marketAnalysis/MarketAnalysisKpis";
import MarketAnalysisPerformance from "@/components/marketAnalysis/MarketAnalysisPerformance";

export default {
    name: 'MarketDataSection',

    components: {
        MarketAnalysisChart,
        MarketAnalysisKpis,
        MarketAnalysisPerformance,
    },
    
}
